import React from "react";
import "./CSS/OurApproach.css";
import loomImg from "./IMAGES/Luxury minimal chair.png"; 

const OurApproach = () => {
  return (
    <section className="approach">
      <div className="approach-container">
        
        {/* LEFT CONTENT */}
        <div className="approach-left">
          <p className="approach-tag">• Our Approach</p>

          <h1>
            Crafted With <br />
            Care, Worn With <br />
            Pride
          </h1>

          <p className="approach-text">
          From the very first thread to the final finish, every saree we create is a reflection of dedication and artistry. We begin by selecting the finest fabrics, chosen for their texture, durability, and elegance. Skilled artisans then bring each piece to life through intricate embroidery and handcrafted detailing, preserving age-old techniques while embracing modern aesthetics. Every stitch, pattern, and finish is carefully inspected to ensure it meets our highest standards—because we believe true beauty lies in the details.  </p>
        </div>

        {/* RIGHT IMAGE */}
        <div className="approach-right">
          <img src={loomImg} alt="Weaving" />
        </div>

      </div>
    </section>
  );
};

export default OurApproach;